<template>
    <div class="loader">
        <dots-loader :size="props.size" />
        <div v-if="props.text" class="loader-text">{{props.text}}</div>
    </div>
</template>

<script setup lang="ts">
import DotsLoader from '@/components/layout/DotsLoader.vue';

const props = defineProps<{
    text?: string;
    size?: 'small';
}>();

</script>

<style scoped lang="scss">
.loader {
    width: 100%;
    height: 100%;
    display: grid;
    place-content: center;
    font-size: var(--defaultFontSize);
    gap: var(--largeSpacing);
}
</style>
